import { Injectable } from '@angular/core';
import { AccessRole } from '../../shared/enums/AccessRole';
import { UserInfoResponse } from '../../shared/interfaces/database/auth';

@Injectable({
  providedIn: 'root'
})
export class LocalService {
  readonly tokenKey = 'access-token';
  readonly refreshTokenKey = 'refresh-token'
  readonly expirationKey = 'expiration';
  readonly refreshExpirationKey = 'refresh-expiration';
  readonly authoritiesKey = 'authorities';
  readonly subKey = 'sub';
  
  readonly USER_KEY = 'auth-user';
  readonly CHECKED_TRAMITES_PENDIENTES = 'checked-tramites-pendientes';
  readonly SHOW_INSTRUCTIVO = 'show-instructivo';

  constructor() { }

  get isRefreshCookieExpired(): boolean {
    return new Date(this.getUser.refreshExpirationDate) < new Date();
  }

  get isFirmaElectronicaHabilitada(): boolean {
    return this.getUser.firmaElectronicaVencimiento !== null && this.getUser.firmaElectronicaVencimiento !== undefined;
  }

  get isFirmaElectronicaExpired(): boolean {
    if(this.isFirmaElectronicaHabilitada) {
      return new Date(this.getUser.firmaElectronicaVencimiento) < new Date();
    }
    return true;
  }

  get isFirmaElectronicaProximaVencimiento(): boolean {
    if(!this.getUser.firmaElectronicaVencimiento){
      return true;
    }
    const today = new Date();
    const expirationDate = new  Date(this.getUser.firmaElectronicaVencimiento);
    // Calculate the difference in months
    const monthsDiff = (expirationDate.getFullYear() - today.getFullYear()) * 12 + 
                      (expirationDate.getMonth() - today.getMonth());
    
    return monthsDiff <= 1;
  }

  get checkedTramitesPendientes(): boolean {
    return JSON.parse(localStorage.getItem(this.CHECKED_TRAMITES_PENDIENTES) ?? 'false');
  }

  set checkedTramitesPendientes(value: boolean) {
    localStorage.setItem(this.CHECKED_TRAMITES_PENDIENTES, JSON.stringify(value));
  }

  get getUser(): UserInfoResponse {
    const user = localStorage.getItem(this.USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {} as UserInfoResponse;
  } 

  get showInstructivo(): boolean {
    return JSON.parse(localStorage.getItem(this.SHOW_INSTRUCTIVO) ?? 'true');
  }

  set showInstructivo(value: boolean) {
    localStorage.setItem(this.SHOW_INSTRUCTIVO, JSON.stringify(value));
  }

  get isLoggedIn(): boolean {
    const user = localStorage.getItem(this.USER_KEY);
    if (user) {
      return true;
    }
    return false;
  }

  saveUser(user: UserInfoResponse){
    localStorage.removeItem(this.USER_KEY);
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    localStorage.setItem(this.CHECKED_TRAMITES_PENDIENTES, 'false');
  }

  public clear() {
    localStorage.clear();
  }

  public hasRole(accessRole: AccessRole): boolean {
    const user = this.getUser;
    return user.roles.includes(accessRole);
  }

}
